import React from 'react';

const Login = () => {
    // If we were bounced back from the YouTube OAuth flow with an error, surface it.
    const params = new URLSearchParams(window.location.search);
    const ytError = params.get('ytError');

    const errorLabel = (() => {
        if (!ytError) return '';
        switch (ytError) {
            case 'access_denied':
                return 'Has cancelado el inicio de sesión con YouTube.';
            case 'missing_params':
                return 'Faltan parámetros del inicio de sesión con YouTube.';
            case 'server_error':
                return 'Hubo un problema iniciando sesión con YouTube. Inténtalo de nuevo.';
            case 'account_conflict':
                return 'Este canal ya está vinculado a otra cuenta de Google.';
            default:
                return 'Error iniciando sesión con YouTube (' + ytError + ').';
        }
    })();

    return (
        <div className="core">
            <a className='btnTwitch heroes' href='/login?twitch=1'>Conectarse con Twitch</a>
            <a className='btnYoutube heroes' href='/login?youtube=1'>Conectarse con YouTube</a>
            {errorLabel ? (
                <p
                    role='alert'
                    style={{
                        marginTop: 12,
                        padding: '8px 12px',
                        borderRadius: 4,
                        backgroundColor: '#fdecea',
                        color: '#8a1a1a',
                        fontWeight: 600
                    }}
                >
                    {errorLabel}
                </p>
            ) : null}
        </div>
    )
}

export default Login;
